exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nut-dialog-image{width:100%;height:100%}.cube-toast-tip{max-height:5.333333rem}", ""]);

// exports
